// extracted by mini-css-extract-plugin
export default {"wrapper":"carol_wrapper__a12Nl","inside":"carol_inside__9eUcd","links":"carol_links__zZsKV"};